var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { noop } from 'lodash';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { stringBuilder } from '../util';
const TuxBasicInput = forwardRef(function TuxBasicInput(props, ref) {
    const { disabled = false, inputClasses, invalid = false, isClearable = false, large = false, onClear = noop, plainText = false, readonly = false, small = false, value } = props, rest = __rest(props, ["disabled", "inputClasses", "invalid", "isClearable", "large", "onClear", "plainText", "readonly", "small", "value"]);
    const inputRef = useRef(null);
    const showClearButton = isClearable && !disabled && value.length > 0;
    const inputClassName = stringBuilder({
        'form-control': !(readonly && plainText),
        'form-control-lg': large,
        'form-control-sm': small,
        'form-control-plaintext': readonly && plainText,
        'is-invalid': invalid
    }, inputClasses);
    useImperativeHandle(ref, () => ({
        focus: () => {
            var _a;
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }));
    const handleClear = () => {
        if (!!inputRef && !!inputRef.current) {
            inputRef.current.focus();
            onClear();
        }
    };
    return (_jsxs("div", Object.assign({ className: "text-input" }, { children: [_jsx("input", Object.assign({}, rest, { "aria-invalid": invalid, className: inputClassName, disabled: disabled, readOnly: readonly, ref: inputRef, value: value }), void 0), showClearButton && (_jsx("button", { "aria-label": "Clear field", className: "clear-button unstyled", onClick: handleClear, type: "button" }, void 0))] }), void 0));
});
export default TuxBasicInput;
